import React from 'react';
import styled from 'styled-components';
import ChevronRight from '@material-ui/icons/ChevronRight';
import StaticMapBoxMap from '../../../../MapBox/StaticMap';
import Marker from '../../../../MapBox/Marker';
import CostEstimatePin from '../../../../SolvPatternLibrary/InteractiveMap/CostEstimatePin';
import { fontFamily, fontSize } from '../../../../../constants/text';
import { colors } from '../../../../../constants/colors';
import VisitDetails from '../components/VisitDetails';
import Label, { LabelColors, LabelText } from '../components/Label';
import GenericRow from '../components/GenericRow';
import UpdateApp from '../components/UpdateApp';
import { getAddress, getRowsProps } from './util';
import { BookingStatus } from '../../../../../constants';
import { isAddressHidden } from '../../../../../core/util/location';
import { isTelemedBooking } from '../../../../../core/util/booking';
import useGetCalendarTime from '~/components/AccountGetsMarried/hooks/useGetCalendarTime';

const Root = styled.div.withConfig({ componentId: 'sc-1scwjjk-0' })`
  max-width: 100%;
  border-radius: 8px;
  background-color: ${colors.theWhiteAlbum};
  color: ${colors.squid};
  font-family: ${fontFamily.book};
  font-size: ${fontSize.mediumSmall};
`;

const Address = styled.div.withConfig({ componentId: 'sc-1scwjjk-1' })`
  color: ${colors.blueLoadingScreen};
  padding-top: 12px;
  display: flex;
  img {
    height: 16px;
    padding-right: 8px;
  }
`;

const Chevron = styled(ChevronRight).withConfig({ componentId: 'sc-1scwjjk-2' })`
  path {
    color: ${colors.lightText};
  }
`;

type Props = {
  appointmentDate?: string;
  booking: any;
  bookingHasInsuranceInfo?: boolean;
  bookingInsurerType?: string;
  bookingTimeZone?: string;
  location?: any;
  userProfileId?: string;
};

const Upcoming = (props: Props) => {
  const {
    appointmentDate,
    booking,
    bookingHasInsuranceInfo,
    bookingInsurerType,
    bookingTimeZone,
    location,
    userProfileId,
  } = props;

  const rowsProps = getRowsProps(
    booking,
    bookingHasInsuranceInfo,
    bookingInsurerType,
    location,
    userProfileId
  );

  const shouldShowMapAndAddress = () => !isTelemedBooking(booking) && !isAddressHidden(location);
  const upcomingBookingDateTime = useGetCalendarTime(booking);

  const getLabel = () => {
    if (BookingStatus.IN_VISIT.includes(booking.status)) {
      return <Label label={LabelText.IN_VISIT} labelColor={LabelColors.IN_VISIT} />;
    }
    return <Label label={LabelText.UPCOMING} labelColor={LabelColors.UPCOMING} />;
  };

  if (!location) return null;

  return (
    <Root>
      {getLabel()}

      <VisitDetails appointmentDate={upcomingBookingDateTime} booking={booking} location={location}>
        {shouldShowMapAndAddress() && (
          <>
            {location.latLong && (
              <StaticMapBoxMap height={180} latLong={location.latLong} width={480} zoom={11}>
                <Marker
                  latitude={location.latLong.latitude}
                  longitude={location.latLong.longitude}
                  pin={CostEstimatePin}
                />
              </StaticMapBoxMap>
            )}

            <Address>
              <img alt="marker" role="presentation" src="/images/icons/map_pin_gray.svg" />
              {getAddress(location)}
            </Address>
          </>
        )}
      </VisitDetails>

      {rowsProps.map(
        (row) =>
          row.shouldShow && (
            <GenericRow key={row.text} onClick={row.onClick}>
              {row.text}

              <Chevron />
            </GenericRow>
          )
      )}

      <UpdateApp location={location} />
    </Root>
  );
};

export default Upcoming;
